import script from "./SearchProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchProjects.vue?vue&type=script&setup=true&lang=js"

import "./SearchProjects.vue?vue&type=style&index=0&id=5e20d526&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e20d526"]])

export default __exports__